import React, { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { setCredentials } from './store/authSlice';
import { RootState } from './store';

// Screens
import LoginScreen from './screens/LoginScreen';
import ResetPasswordScreen from './screens/ResetPasswordScreen';
import InviteUserScreen from './screens/InviteUserScreen';
import LandingPage from './screens/LandingPage';
import HomeScreen from './screens/HomeScreen';
import UserManagementScreen from './screens/UserManagementScreen';
import MapScreen from './screens/MapScreen';
import ProjectScreen from './screens/ProjectScreen';
import ProjectViewScreen from './screens/ProjectViewScreen';
import ProjectProgressScreen from './screens/ProjectProgressScreen';
import ProjectManagementScreen from './screens/ProjectManagementScreen';
import CourseElementsScreen from './screens/CourseElementsScreen';
import ProfileScreen from './screens/ProfileScreen';
import PrivacyPolicy from './screens/PrivacyPolicy';
import AccountDeleteInfo from './screens/AccountDeleteInfo';

import NavBar from './components/NavBar';
import './App.css';

function App() {
  const dispatch = useDispatch();
  const { user, token } = useSelector((state: RootState) => state.auth);

  useEffect(() => {
    const storedToken = localStorage.getItem('token');
    const storedUser = localStorage.getItem('user');

    if (storedToken && storedUser) {
      try {
        const parsedUser = JSON.parse(storedUser);
        dispatch(setCredentials({ user: parsedUser, token: storedToken }));
      } catch (e) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
      }
    }
  }, [dispatch]);

  // NOTE: Client auto-redirect is handled in HomeScreen component

  return (
    <div className="App">
      {token && <NavBar />}
      <Routes>
        <Route path="/" element={token ? <HomeScreen /> : <LandingPage />} />
        <Route path="/login" element={<LoginScreen />} />
        <Route path="/reset-password" element={<ResetPasswordScreen />} />
        <Route path="/invite" element={<InviteUserScreen />} />
        <Route path="/profile" element={token ? <ProfileScreen /> : <Navigate to="/" replace />} />
        <Route path="/users" element={token && user?.role === 'admin' ? <UserManagementScreen /> : <Navigate to="/" replace />} />
        <Route path="/projects" element={token ? <ProjectScreen /> : <Navigate to="/" replace />} />
        <Route path="/map/:projectId?" element={token ? <MapScreen /> : <Navigate to="/" replace />} />
        <Route path="/project/:projectId" element={token ? <ProjectViewScreen /> : <Navigate to="/" replace />} />
        <Route path="/project/:projectId/progress" element={token ? <ProjectProgressScreen /> : <Navigate to="/" replace />} />
        <Route path="/project/:projectId/management" element={token && (user?.role === 'admin' || user?.role === 'designer') ? <ProjectManagementScreen /> : <Navigate to="/" replace />} />
        <Route path="/course-elements/:projectId?" element={token ? <CourseElementsScreen /> : <Navigate to="/" replace />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/request-account-removal" element={<AccountDeleteInfo />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}

export default App;
